import { Routes, Route } from "react-router-dom";
import AdminLogin from "./Components/Login.jsx";
import AdminLayout from "./Components/AdminLayout.jsx";
import Dashboard from "./Components/Dashboard.jsx";
import Courses from "./Components/Courses.jsx";
import Categories from "./Components/Categories.jsx";
import Users from "./Components/Users.jsx";
import Documents from "./Components/Documents.jsx";
import Resumemanager from "./Components/Resume.jsx";
import FaqsPage from "./Components/FaqsPage.jsx";
import LecturersPage from "./Components/Lecturers.jsx";
import CourseCategoriesPage from "./Components/CourseCategories.jsx";
import ProgramCategoriesPage from "./Components/ProgramCategories.jsx";
import ProgramsPage from "./Components/Programs.jsx";
import ReviewsRatingsPage from "./Components/ReviewsRatings.jsx";
import SettingsPage from "./Components/Settings.jsx";
import DepartmentsPage from "./Components/Departments.jsx";
import SubscriptionAdmin from "./Components/SubscriptionAdmin.jsx";
import SubscribedUsers from "./Components/SubscribedUsers.jsx";
import ResumeSubscribedUsersPage from "./Components/ResumeSubscribedUsers.jsx";
import SupportCategoriesPage from "./Components/SupportCategories.jsx";
import SupportTicketsPage from "./Components/SupportTickets.jsx";

import ProtectedRoute from "./config/ProtectedRoute.jsx";
import { AuthProvider } from "./context/AuthContext.jsx";
import { UserProvider } from "./context/UserContext";
import { CategoryProvider } from "./context/CategoryContext.jsx";
import { FaqProvider } from "./context/FaqContext.jsx";
import { SupportCategoryProvider } from "./context/SupportCategoryContext.jsx";
import { SupportTicketProvider } from "./context/SupportTicketContext.jsx";

function App() {
  return (
      <AuthProvider>
        <Routes>

          {/* Login */}
          <Route path="/" element={<AdminLogin />} />

          {/* Protected Admin Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="categories" element={<CategoryProvider><Categories /></CategoryProvider>} />
            <Route path="course-categories" element={<CourseCategoriesPage />} />
            <Route path="courses" element={<Courses />} />
            <Route path="program-categories" element={<ProgramCategoriesPage />} />
            <Route path="departments" element={<DepartmentsPage />} />
            <Route path="subscription-plans" element={<SubscriptionAdmin />} />
            <Route path="subscribed-users" element={<SubscribedUsers />} />
            <Route path="resume-subscribed-users" element={<ResumeSubscribedUsersPage />} />

            <Route path="programs" element={<ProgramsPage />} />
            <Route path="lecturers" element={<LecturersPage />} />
            <Route path="users" element={ <UserProvider><Users /></UserProvider>} />
            <Route path="documents" element={<Documents />} />
            <Route path="resume" element={<Resumemanager />} />
            <Route path="reviews-ratings" element={<ReviewsRatingsPage />} />
            <Route path="faqs" element={<FaqProvider><FaqsPage /></FaqProvider>} />
            <Route path="support-categories" element={<SupportCategoryProvider><SupportCategoriesPage /></SupportCategoryProvider>} />
            <Route path="support-tickets" element={<SupportTicketProvider><SupportTicketsPage /></SupportTicketProvider>} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>

        </Routes>
      </AuthProvider>
  );
}

export default App;